const tasksHeaderReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_TASK_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_TASK_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default tasksHeaderReducer;
  